/**
 * Validates if a string is a valid MongoDB ObjectId
 * @param id The string to validate
 * @returns boolean indicating if the string is a valid ObjectId
 */
export const isValidObjectId = (id: string): boolean => {
  // MongoDB ObjectId is a 24 character hex string
  return Boolean(id) && typeof id === 'string' && /^[0-9a-fA-F]{24}$/.test(id);
};
